import React from 'react'
import {
  MDXEditor,
  headingsPlugin,
  listsPlugin,
  quotePlugin,
  thematicBreakPlugin,
  markdownShortcutPlugin,
  toolbarPlugin,
  UndoRedo,
  BoldItalicUnderlineToggles,
  BlockTypeSelect,
  ListsToggle,
  InsertThematicBreak,
  CreateLink,
  Separator,
} from '@mdxeditor/editor'

const toolbar = toolbarPlugin({
  toolbarClassName: 'custom-toolbar',
  toolbarContents: () => (
    <>
      <UndoRedo />
      <Separator />
      <BoldItalicUnderlineToggles />
      <Separator />
      <BlockTypeSelect />
      <ListsToggle />
      <Separator />
      <InsertThematicBreak />
      <CreateLink />
    </>
  ),
})

const contentPlugins = [
  headingsPlugin(),
  listsPlugin(),
  quotePlugin(),
  thematicBreakPlugin(),
  markdownShortcutPlugin(),
]

export default function App({ markdown = '', definition = {}, onChange }) {
  const readOnly = definition.enabled === false
  const showLabel = definition.label && !definition.hideLabel
  const plugins = readOnly ? contentPlugins : [toolbar, ...contentPlugins]

  return (
    <>
      {showLabel && (
        <label style={{ display: 'block', marginBottom: 4, color: definition.mandatory ? '#d32f2f' : 'inherit' }}>
          {definition.label}{definition.mandatory ? ' *' : ''}
        </label>
      )}
      <div style={{ border: '1px solid #ddd', borderRadius: 6, padding: 12, background: '#f0f0f3' }}>
        <MDXEditor markdown={markdown} readOnly={readOnly} onChange={onChange} plugins={plugins} />
      </div>
    </>
  )
}
